'use strict'

module.exports = async function promiseRetry(method, numberOfRetries) {
  let lastError = null
  for (let index = 0; index < numberOfRetries; index++) {
    try {
      return await method()
    } catch (error) {
      lastError = error
    }
  }
  throw lastError
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/promiseRetry.js